export const INITIAL_STATE = { pet: null }

export default function petReducer(state, action) {
  switch (action.type) {
    case ('setPet'): return { pet: action.payload }
    default: return INITIAL_STATE
  }
}

export function setPet(payload) {
  return { type: 'setPet', payload }
}
